import { render } from "./DiscountTypeAdd.vue?vue&type=template&id=5323c0b2&scoped=true"
import script from "./DiscountTypeAdd.vue?vue&type=script&lang=js"
export * from "./DiscountTypeAdd.vue?vue&type=script&lang=js"

import "./DiscountTypeAdd.vue?vue&type=style&index=0&id=5323c0b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5323c0b2"]])

export default __exports__